import { DEEPTALK_INTEGRATION_BASE_URL } from '../constants';
import api from '../utils/ApiKit';
import { GetIntegrationsRes } from './integrations.interfaces';

export const getActivatedIntegrationsReq = (accId: string) =>
  api.getInstance().get<GetIntegrationsRes>(`${DEEPTALK_INTEGRATION_BASE_URL}integrations`);